import { SuperInput } from "@components:SuperInput/SuperInput";
import { Box } from "@mui/material";
import { useRef } from "react";

import { FieldLabel } from "./shared-styles";

interface ColorPickerFieldProps {
  value: string;
  onChange: (value: string) => void;
  label: string;
}

export const ColorPickerField = ({
  value,
  onChange,
  label,
}: ColorPickerFieldProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <Box sx={{ flex: 1 }}>
      <FieldLabel>{label}</FieldLabel>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Box
          onClick={() => inputRef.current?.click()}
          sx={{
            width: 36,
            height: 36,
            borderRadius: 1,
            bgcolor: value,
            cursor: "pointer",
            border: "1px solid rgba(0,0,0,0.1)",
            flexShrink: 0,
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            transition: "transform 0.15s ease",
            "&:hover": { transform: "scale(1.02)" },
          }}
        />
        <input
          ref={inputRef}
          type="color"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          style={{ position: "absolute", opacity: 0, width: 0, height: 0 }}
        />
        <SuperInput.TextField
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="#000000"
          size="small"
          autoHeight={false}
          sx={{
            flex: 1,
            "& .MuiOutlinedInput-root": {
              fontSize: "0.8rem",
              fontWeight: 500,
            },
            "& .MuiOutlinedInput-input": {
              py: 1,
              px: 1.25,
            },
          }}
        />
      </Box>
    </Box>
  );
};
